import makeStyles from '@ui/utils/makeStyles';

export default makeStyles()((theme) => ({

  userCardName: {
    marginTop: theme.spacing(2),
    fontWeight: 500,
    fontSize: 16,
    color: theme.palette.common.black,
    [theme.breakpoints.up('md')]: {
      fontSize: 24,
    }
  },
}));
